export const PICKUP_CARRIER = {
  id: 1,
  humanReadableName: 'Pickup',
  name: 'pickup',
  iconUrl: '/market_icons/pickup.png'
}
export const FEDEX_CARRIER = {
  id: 2,
  humanReadableName: 'FedEx',
  name: 'fedex',
  iconUrl: '/market_icons/fedex.png'
}
export const UPS_CARRIER = {
  id: 3,
  humanReadableName: 'UPS',
  name: 'ups',
  iconUrl: '/market_icons/ups.png'
}
export const USPS_CARRIER = {
  id: 4,
  humanReadableName: 'USPS',
  name: 'usps',
  iconUrl: '/market_icons/usps.png'
}
export const CANADA_POST_CARRIER = {
  id: 5,
  humanReadableName: 'Canada Post',
  name: 'canada_post',
  iconUrl: '/market_icons/canadapost.png'
}

const CARRIERS = {
  1: PICKUP_CARRIER,
  2: FEDEX_CARRIER,
  3: UPS_CARRIER,
  4: USPS_CARRIER,
  5: CANADA_POST_CARRIER
}

export default CARRIERS
